import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import {
    type PropType,
    computed,
    defineAsyncComponent,
    ref,
    onMounted,
} from "vue";
import labels from "../../shared/labels";
import { type ShopProduct } from "./types";
import { getBreakpointObservable } from "../../../../shared/breakpoint-observable";
import { elementVisible } from "../../frontend-productgallery/element-intersection";


export default /*@__PURE__*/_defineComponent({
  __name: 'related-products',
  props: {
    product: {
        type: Object as PropType<ShopProduct>,
        required: true,
    },
},
  setup(__props) {

const productGallery = defineAsyncComponent(
    () =>
        import(
            /* webpackFetchPriority: "high" */
            "../../frontend-productgallery/ProductGallery.vue"
        )
);


const visible = ref(false);

const breakpointObserver = getBreakpointObservable();

const currentBreakpoint = computed(() => {
    return breakpointObserver.currentBreakpoint;
});
const productsPerRow = computed(() => {
    if (currentBreakpoint.value?.up("lg") == true) return 5;
    return 2;
});

const intersectionObserver = ref<IntersectionObserver>();

const interscetionCallback: IntersectionObserverCallback = (entries) => {
    entries.forEach((x) => {
        if ((visible.value = x.intersectionRatio > 0)) {
            console.log("now visible");
            intersectionObserver.value?.disconnect();
        }
    });
};

const root = ref<HTMLDivElement>();

onMounted(() => {
    if (
        root.value != null &&
        root.value instanceof HTMLElement
    ) {
        if (elementVisible(root.value)) {
            visible.value = true;
        } else {
            const options: IntersectionObserverInit = {
                root: document.body,
                rootMargin: "0px",
                threshold: 1.0,
            };

            intersectionObserver.value = new IntersectionObserver(
                interscetionCallback,
                options
            );
            intersectionObserver.value.observe(root.value);
        }
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style['related-comp']),
    ref_key: "root",
    ref: root
  }, [
    (
                __props.product.relatedProductsUrl != null &&
                __props.product.relatedProductsUrl != '' &&
                visible.value
            )
      ? (_openBlock(), _createBlock(_unref(productGallery), {
          key: 0,
          "products-per-row": productsPerRow.value,
          "fetch-url": __props.product.relatedProductsUrl
        }, {
          "top-part": _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style['header'])
            }, _toDisplayString(_unref(labels).frontendProductpage.shop
                            .recommendedProductsHeader), 3 /* TEXT, CLASS */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["products-per-row", "fetch-url"]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})